import React from "react";
import { useEffect, useRef, useState } from "react";
import "../styles/PromotionsAndMarketing.css";
import PromotionAndMarketing from "../icons/PromotionAndMarketing";
import CriditsIcon from "../icons/CriditsIcon";
import ThreeDots from "../icons/BusinessHub/ThreeDots";
import DateIcon from "../icons/BusinessHub/DateIcon";
import DiscountIcon from "../icons/DiscountIcon";
import ProductManagmentIcon from "../icons/BusinessHub/ProductManagmentIcon";
import CustomDropdown from "./StatusDropdown";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon";
import DateRangePicker from "./DateRangePicker";
import PlusIcon from "../icons/BusinessHub/PlusIcon";
import SearchIcon from "../icons/BusinessHub/SearchIcon";
import FilterIcon from "../icons/BusinessHub/FilterIcon";
import { useNavigate } from "react-router-dom";
import Lightingn from "../icons/Lightingn";
import CrownIcon from "../icons/CrownIcon";
import RocketIcon from "../icons/RocketIcon";
import ArrowBackIcon from "../icons/BusinessHub/ArrowBackIcon";
import ArrowFront from "../icons/BusinessHub/ArrowFront";
import StarsIcons from "../icons/StarsIcons";
import StarIcon from "../icons/StarIcon";
import EyeViewOpened from "../icons/BusinessHub/EyeViewOpened";
import PensilIcon from "../icons/BusinessHub/PensilIcon";
import ProductController from "../controllers/ProductController";
import { userService } from "../services/userService";
import XIcon from "../icons/XIcon";
import PromotionController from "../controllers/PromotionController";
import Utils from "../utils/Utils";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon";
import { toast } from "react-toastify";

function PromotionsAndMarketing() {
  const navigate = useNavigate();
  const openPromotionDetails = (mode, productOfferId) => {
    const params = new URLSearchParams({
      view: "promotion-details",
      mode,
      pid: String(productOfferId || ""),
    });
    navigate(`/promotions-and-marketing?${params.toString()}`);
  };

  const openFeaturedPlacement = (mode, productOfferId) => {
    const params = new URLSearchParams({
      view: "featured-placement",
      mode,
      productOfferId: String(productOfferId || ""),
    });
    navigate(`/promotions-and-marketing?${params.toString()}`);
  };

  const campaignSteps = [
    { id: 1, label: "Details" },
    { id: 2, label: "Products" },
    { id: 3, label: "Discount" },
    { id: 4, label: "Review" },
  ];
  const featureSteps = [
    { id: 1, label: "Duration" },
    { id: 2, label: "Products" },
    { id: 3, label: "Review" },
  ];
  const [BillingPlans, setBillingPlans] = useState([]);
  const [creditSummary, setCreditSummary] = useState(null);
  const [rawBillingPlans, setRawBillingPlans] = useState([]);
  const [selectedBillingPlanId, setSelectedBillingPlanId] = useState("");
  const [CampaignName, setCampaignName] = useState([]);
  const [promotions, setpromotions] = useState([]);
  const [features, setfeatures] = useState([]);
  const [featureMockProducts, setfeatureMockProducts] = useState([]);
  const [mockcategories, setmockcategories] = useState([]);
  const [mockproducts, setmockproducts] = useState([]);
  useEffect(() => {
    const getdata = async () => {
      const res = await ProductController.getAllCategories({
        Authorization: userService.getUser(),
      });
      const normalized = (res?.data || []).map((c) => ({
        id: c.categoryId,
        name: c.categoryName,
      }));
      setmockcategories(normalized);
    };
    getdata();
  }, []);

  const [FeatureView, setFeatureView] = useState(null);
  const [PromotionVeiw, setPromotionVeiw] = useState(null);
  const PromotionVeiwRef = useRef(null);

  const featureViewRef = useRef(null);
  const [NewCam, setNewCam] = useState(false);
  const [active, setActive] = useState("active-promotions");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [categoryFilterID, setCategoryFilterID] = useState("");
  const [offerType, setOfferType] = useState("");

  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL_STATUS");
  const [campaignCategory, setCampaignCategory] = useState("");
  const [discountUnit, setDiscountUnit] = useState("PERCENTAGE");
  const [isPromotionModalOpen, setIsPromotionModalOpen] = useState(false);
  const [isFeatureModalOpen, setIsFeatureModalOpen] = useState(false);
  const [discount, setdiscount] = useState("");
  const [campaignDescription, setCampaignDescription] = useState("");
  const [campaignRange, setCampaignRange] = useState({ from: "", to: "" });
  const [currentCampaignStep, setCurrentCampaignStep] = useState(1);
  const [featureRange, setFeatureRange] = useState({ from: "", to: "" });
  const [currentFeatureStep, setCurrentFeatureStep] = useState(1);
  const [featureShowCategoryFilter, setFeatureShowCategoryFilter] =
    useState(true);
  const [featureCategorySearch, setFeatureCategorySearch] = useState("");
  const [featureProductSearch, setFeatureProductSearch] = useState("");
  const [featureSelectedCategories, setFeatureSelectedCategories] = useState(
    [],
  );
  const [featureExpandedProducts, setFeatureExpandedProducts] = useState([]);
  const [featureSelectedProducts, setFeatureSelectedProducts] = useState([]);
  const [featureSelectedSkus, setFeatureSelectedSkus] = useState([]);
  const [newCampaignName, setNewCampaignName] = useState("");
  const [showcategoryfilter, setShowcategoryfilter] = useState(false);
  const [categorysearch, setCategorysearch] = useState("");
  const [productsearch, setProductsearch] = useState("");
  const [expandedproducts, setExpandedproducts] = useState([]);
  const [selectedcategories, setSelectedcategories] = useState([]);
  const [selectedproducts, setSelectedproducts] = useState([]);
  const [selectedskus, setSelectedskus] = useState([]);

  useEffect(() => {
    if (FeatureView === null) return undefined;
    const handlePointerDown = (event) => {
      if (
        featureViewRef.current &&
        !featureViewRef.current.contains(event.target)
      ) {
        setFeatureView(null);
      }
    };
    document.addEventListener("mousedown", handlePointerDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
    };
  }, [FeatureView]);

  useEffect(() => {
    if (PromotionVeiw === null) return undefined;
    const handlePointerDown = (event) => {
      if (
        PromotionVeiwRef.current &&
        !PromotionVeiwRef.current.contains(event.target)
      ) {
        setPromotionVeiw(null);
      }
    };
    document.addEventListener("mousedown", handlePointerDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
    };
  }, [PromotionVeiw]);

  const formatreviewdate = (value) => {
    if (!value) return "";

    const [day, month, year] = value.split("/");

    const parsed = new Date(Number(year), Number(month) - 1, Number(day));

    if (Number.isNaN(parsed.getTime())) {
      return value;
    }

    const monthName = parsed.toLocaleString("en-US", {
      month: "short",
    });

    const dayNumber = parsed.getDate();
    const fullYear = parsed.getFullYear();

    return `${monthName} ${dayNumber},${fullYear}`;
  };

  const reviewduration =
    campaignRange.from && campaignRange.to
      ? `${formatreviewdate(campaignRange.from)}\u00A0\u00A0\u00A0to\u00A0\u00A0\u00A0${formatreviewdate(
          campaignRange.to,
        )}`
      : "No date range selected";

  const selectedproductdetails = mockproducts.filter((product) =>
    selectedproducts.includes(product.id),
  );
  const selectedskudetails = mockproducts.flatMap((product) =>
    product.skus.filter((sku) => selectedskus.includes(sku.id)),
  );

  const uniqueCategories = Array.from(
    new Map(mockcategories.map((c) => [c.id, c])).values(),
  );
  const selectedCampaignCategories = uniqueCategories.filter((category) =>
    selectedcategories.includes(category.id),
  );
  const selectedCampaignCategoryIds = selectedCampaignCategories.map(
    (category) => category.id,
  );
  const selectedCampaignCategoryNames = selectedCampaignCategories.map(
    (category) => category.name,
  );
  const selectedCampaignCategoryIdsKey = selectedCampaignCategoryIds.join("|");
  const visibleproducts = mockproducts.filter((product) => {
    const productCategoryId = product.categoryId;
    const productCategory =
      product.categoryName ??
      (typeof product.category === "string"
        ? product.category
        : product.category?.categoryName || "");

    return (
      (!selectedCampaignCategoryIds?.length ||
        selectedCampaignCategoryIds.includes(productCategoryId) ||
        selectedCampaignCategoryNames.includes(productCategory)) &&
      `${product.name} ${product.vendor} ${productCategory} ${product.skus
        .map((sku) => `${sku.name} ${sku.code}`)
        .join(" ")}`
        .toLowerCase()
        .includes(productsearch.toLowerCase())
    );
  });
  const filteredcategoryoptions = uniqueCategories.filter((category) =>
    category.name?.toLowerCase().includes((categorysearch || "").toLowerCase()),
  );

  const featureCategoryOptions = Array.from(
    new Map(mockcategories.map((category) => [category.id, category])).values(),
  );
  const featureSelectedCategoryDetails = featureCategoryOptions.filter(
    (category) => featureSelectedCategories.includes(category.id),
  );
  const featureSelectedCategoryIds = featureSelectedCategoryDetails.map(
    (category) => category.id,
  );
  const featureSelectedCategoryNames = featureSelectedCategoryDetails.map(
    (category) => category.name,
  );
  const featureSelectedCategoryIdsKey = featureSelectedCategoryIds.join("|");
  const featureFilteredCategoryOptions = featureCategoryOptions.filter(
    (category) =>
      `${category.name || ""}`
        .toLowerCase()
        .includes((featureCategorySearch || "").toLowerCase()),
  );

  const normalizeSkuIds = (product, productId) => {
    const skuIds = Array.isArray(product?.skuIDs)
      ? product.skuIDs
      : Array.isArray(product?.skuIds)
        ? product.skuIds
        : product?.skuID
          ? [product.skuID]
          : [];

    return skuIds.filter(Boolean).map((skuId, skuIndex) => ({
      id: String(skuId),
      skuID: String(skuId),
      name: String(skuId),
      code: product?.skuCode ?? `SKU ${skuIndex + 1}`,
      stock: product?.stockQuantity ?? product?.quantity ?? product?.stock ?? 0,
      productId,
    }));
  };

  const normalizeFeatureProduct = (product, productIndex) => {
    const productId =
      product?.productID ??
      product?.productId ??
      product?.id ??
      product?.catalogId ??
      product?.productCatalogId ??
      `feature-product-${productIndex + 1}`;

    const productName =
      product?.productName ??
      product?.name ??
      product?.title ??
      product?.productTitle ??
      "Unnamed Product";

    const productCategory =
      product?.categoryName ??
      product?.categoryName ??
      product?.category ??
      product?.productCategory ??
      "";
    const productCategoryId =
      product?.categoryId ??
      product?.categoryID ??
      product?.basicInfo?.categoryId ??
      "";

    const normalizedSkus = normalizeSkuIds(product, productId);

    return {
      ...product,
      id: productId,
      productID: productId,
      name: productName,
      categoryId: productCategoryId,
      category: productCategory,
      categoryName: product?.categoryName ?? productCategory,
      vendor: product?.vendorName ?? product?.vendor ?? product?.brand ?? "",
      image: product?.image ?? product?.imageUrl ?? product?.productImage ?? "",
      skus: normalizedSkus,
    };
  };

  const normalizeCampaignProduct = (product, productIndex) => {
    const productId =
      product?.productID ??
      product?.productId ??
      product?.id ??
      product?.catalogId ??
      product?.productCatalogId ??
      `campaign-product-${productIndex + 1}`;

    const productName =
      product?.productName ??
      product?.name ??
      product?.title ??
      product?.productTitle ??
      "Unnamed Product";

    const productCategory =
      product?.categoryName ??
      product?.category ??
      product?.productCategory ??
      "";
    const productCategoryId =
      product?.categoryId ??
      product?.categoryID ??
      product?.basicInfo?.categoryId ??
      "";

    const normalizedSkus = normalizeSkuIds(product, productId);

    return {
      ...product,
      id: productId,
      productID: productId,
      name: productName,
      categoryId: productCategoryId,
      category: productCategory,
      categoryName: product?.categoryName ?? productCategory,
      vendor: product?.vendorName ?? product?.vendor ?? product?.brand ?? "",
      image: product?.image ?? product?.imageUrl ?? product?.productImage ?? "",
      skus: normalizedSkus,
    };
  };

  const visibleFeatureProducts = (
    Array.isArray(featureMockProducts) ? featureMockProducts : []
  ).filter((product) => {
    const categoryId = product?.categoryId;
    const categoryName =
      product?.categoryName ??
      (typeof product.category === "string"
        ? product.category
        : product.category?.categoryName || "");

    const search = (featureProductSearch || "").toLowerCase();

    const skusText = Array.isArray(product.skus)
      ? product.skus
          .map((sku) => `${sku?.name || ""} ${sku?.code || ""}`)
          .join(" ")
      : "";

    const fullText =
      `${product?.name || ""} ${product?.vendor || ""} ${categoryName} ${skusText}`.toLowerCase();

    return (
      (!featureSelectedCategoryIds?.length ||
        featureSelectedCategoryIds.includes(categoryId) ||
        featureSelectedCategoryNames.includes(categoryName)) &&
      fullText.includes(search)
    );
  });

  const formatDate = (dateValue) =>
    new Date(dateValue).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

  const featureReviewDuration =
    featureRange.from && featureRange.to
      ? `${formatreviewdate(featureRange.from)} to ${formatreviewdate(
          featureRange.to,
        )}`
      : "No date range selected";
  const normalizedSearchValue = (searchValue || "").trim().toLowerCase();
  const normalizePromotionStatus = (value) => {
    const normalizedStatus = String(value || "")
      .trim()
      .toUpperCase();

    if (normalizedStatus === "UPCOMING" || normalizedStatus === "SCHEDULED") {
      return "UPCOMING";
    }

    if (normalizedStatus === "ACTIVE") {
      return "ACTIVE";
    }

    return normalizedStatus;
  };

  const normalizeCategoryDisplayList = (value) => {
    if (Array.isArray(value)) {
      return value.filter(Boolean).map(String);
    }

    if (value && typeof value === "object") {
      const label = value.categoryName || value.name || value.label;
      return label ? [String(label)] : [];
    }

    return value ? [String(value)] : [];
  };

  const getPromotionCategoryNames = (promotion) =>
    normalizeCategoryDisplayList(
      promotion?.categoryName ?? promotion?.category?.categoryName,
    );

  const getFeaturedCategoryNames = (promotion) =>
    normalizeCategoryDisplayList(
      promotion?.products?.[0]?.categoryName ??
        promotion?.categoryName ??
        promotion?.category?.categoryName,
    );

  const filteredPromotions = (
    Array.isArray(promotions) ? promotions : []
  ).filter((promotion) => {
    const promotionStatus = normalizePromotionStatus(
      promotion?.campaignsStatus,
    );
    const matchesStatus =
      statusFilter === "ALL_STATUS" || promotionStatus === statusFilter;

    const searchSource = [
      promotion?.title,
      // promotion?.description,
      getPromotionCategoryNames(promotion).join(" "),
      // promotion?.campaignsStatus,
      promotion?.discountApplied,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    const matchesSearch =
      !normalizedSearchValue || searchSource.includes(normalizedSearchValue);

    return matchesStatus && matchesSearch;
  });
  const featureSelectedProductDetails = (
    Array.isArray(featureMockProducts) ? featureMockProducts : []
  ).filter((product) => featureSelectedProducts.includes(product.id));
  const featureSelectedSkuDetails = (
    Array.isArray(featureMockProducts) ? featureMockProducts : []
  ).flatMap((product) =>
    (Array.isArray(product?.skus) ? product.skus : []).filter((sku) =>
      featureSelectedSkus.includes(sku.id),
    ),
  );
  const availableCreditsValue = Number(creditSummary?.availableCredits ?? 0);
  const total = Number(creditSummary?.totalCredits ?? 0);
  const used = Number(creditSummary?.usedCredits ?? 0);
  const percent =
    total > 0 ? Math.min(Number(creditSummary?.usedPercentage ?? 0), 100) : 0;
  const featureCreditsPerProduct = Math.max(
    getDurationInDays(featureRange.from, featureRange.to),
    0,
  );
  const featureProductsSelectedCount = featureSelectedProductDetails?.length;
  const featureTotalCreditsRequired =
    featureCreditsPerProduct * featureProductsSelectedCount;
  const normalizedBillingPlans = Array.isArray(BillingPlans)
    ? BillingPlans
    : Array.isArray(BillingPlans?.data)
      ? BillingPlans.data
      : [];
  const normalizedRawBillingPlans = Array.isArray(rawBillingPlans)
    ? rawBillingPlans
    : Array.isArray(rawBillingPlans?.data)
      ? rawBillingPlans.data
      : [];

  const mergeBillingPlans = (summaryPlans = [], sourcePlans = []) => {
    const sourceByName = new Map(
      (Array.isArray(sourcePlans) ? sourcePlans : [])
        .filter((plan) => plan?.planName)
        .map((plan) => [String(plan.planName).trim().toLowerCase(), plan]),
    );

    return (Array.isArray(summaryPlans) ? summaryPlans : []).map((plan) => {
      const sourcePlan = sourceByName.get(
        String(plan?.planName || "")
          .trim()
          .toLowerCase(),
      );

      return {
        ...sourcePlan,
        ...plan,
        billingPlanId: plan?.billingPlanId || sourcePlan?.billingPlanId || null,
        billingPlansDetails:
          (Array.isArray(plan?.billingPlansDetails) &&
          plan.billingPlansDetails.length
            ? plan.billingPlansDetails
            : null) ||
          (Array.isArray(sourcePlan?.billingPlansDetails) &&
          sourcePlan.billingPlansDetails.length
            ? sourcePlan.billingPlansDetails
            : null),
        features:
          (Array.isArray(plan?.features) && plan.features.length
            ? plan.features
            : null) ||
          (Array.isArray(sourcePlan?.features) && sourcePlan.features.length
            ? sourcePlan.features
            : null),
      };
    });
  };

  const rowClass = (key) =>
    active === key
      ? "promotion-marketing-nav-item-selected"
      : "promotion-marketing-nav-item";

  const featureRemainingCredits = Math.max(
    availableCreditsValue - featureTotalCreditsRequired,
    0,
  );
  const getBillingPlanIcon = (planName, index) => {
    const normalizedName = String(planName || "").toLowerCase();

    if (normalizedName.includes("growth")) {
      return <Lightingn />;
    }

    if (
      normalizedName.includes("accelerator") ||
      normalizedName.includes("sales")
    ) {
      return <RocketIcon />;
    }

    if (
      normalizedName.includes("max") ||
      normalizedName.includes("revenue") ||
      normalizedName.includes("enterprise")
    ) {
      return <CrownIcon />;
    }

    if (index === 0) return <Lightingn />;
    if (index === 1) return <RocketIcon />;
    return <CrownIcon />;
  };
  const formatBillingButtonLabel = (planName) => {
    if (!planName) return "Purchase Plan";

    const segments = planName.trim().split(/\s+/);
    const shortName = segments[segments.length - 1] || "Plan";

    return `Purchase ${shortName}`;
  };

  const isFirstCampaignStep = currentCampaignStep === 1;
  const isLastCampaignStep = currentCampaignStep === campaignSteps?.length;
  const isFirstFeatureStep = currentFeatureStep === 1;
  const isLastFeatureStep = currentFeatureStep === featureSteps?.length;
  const [activeProm, setactiveProm] = useState("");
  const [scheduledProm, setscheduledProm] = useState("");
  const campaignOptions = CampaignName?.map((campaign) => ({
    label: campaign.campaignName,
    value: campaign.campaignId,
    description: campaign.description,
    offerType: campaign.offerType,
  }));

  const handleCampaignSelect = (selectedValue) => {
    const selectedCampaign = campaignOptions.find(
      (campaign) => campaign.value === selectedValue,
    );
    setCategoryFilter(selectedCampaign?.label || "");
    setCategoryFilterID(selectedCampaign?.value || "");
    setCampaignDescription(selectedCampaign?.description);
    setOfferType(selectedCampaign?.offerType);
  };

  const handleCampaignCategoryToggle = (category) => {
    if (!category) return;

    setSelectedcategories((prev) =>
      prev.includes(category.id)
        ? prev.filter((item) => item !== category.id)
        : [...prev, category.id],
    );
    setCampaignCategory(category.name);
  };

  const handleFeatureCategoryToggle = (category) => {
    if (!category) return;

    setFeatureSelectedCategories((prev) =>
      prev.includes(category.id)
        ? prev.filter((item) => item !== category.id)
        : [...prev, category.id],
    );
  };

  const handleCampaignProductToggle = (product) => {
    const isSelected = selectedproducts.includes(product.id);
    const productSkuIds = product.skus.map((sku) => sku.id);

    if (isSelected) {
      setSelectedproducts((prev) => prev.filter((item) => item !== product.id));
      setExpandedproducts((prev) => prev.filter((item) => item !== product.id));
      setSelectedskus((prev) =>
        prev.filter((skuId) => !productSkuIds.includes(skuId)),
      );
      return;
    }

    setSelectedproducts((prev) => [...prev, product.id]);
    setExpandedproducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
    setSelectedskus((prev) => [
      ...prev,
      ...productSkuIds.filter((skuId) => !prev.includes(skuId)),
    ]);
  };

  const handleCampaignSkuToggle = (product, skuId) => {
    const isSkuSelected = selectedskus.includes(skuId);

    if (isSkuSelected) {
      const remainingSkuIds = product.skus
        .map((sku) => sku.id)
        .filter((id) => id !== skuId && selectedskus.includes(id));

      setSelectedskus((prev) => prev.filter((item) => item !== skuId));
      if (!remainingSkuIds.length) {
        setSelectedproducts((prev) =>
          prev.filter((item) => item !== product.id),
        );
      }
      return;
    }

    setSelectedskus((prev) => [...prev, skuId]);
    setSelectedproducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
    setExpandedproducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
  };

  const handleFeatureProductToggle = (product) => {
    const isSelected = featureSelectedProducts.includes(product.id);
    const productSkuIds = product.skus.map((sku) => sku.id);

    if (isSelected) {
      setFeatureSelectedProducts((prev) =>
        prev.filter((item) => item !== product.id),
      );
      setFeatureExpandedProducts((prev) =>
        prev.filter((item) => item !== product.id),
      );
      setFeatureSelectedSkus((prev) =>
        prev.filter((skuId) => !productSkuIds.includes(skuId)),
      );
      return;
    }

    setFeatureSelectedProducts((prev) => [...prev, product.id]);
    setFeatureExpandedProducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
    setFeatureSelectedSkus((prev) => [
      ...prev,
      ...productSkuIds.filter((skuId) => !prev.includes(skuId)),
    ]);
  };

  const handleFeatureSkuToggle = (product, skuId) => {
    const isSkuSelected = featureSelectedSkus.includes(skuId);

    if (isSkuSelected) {
      const remainingSkuIds = product.skus
        .map((sku) => sku.id)
        .filter((id) => id !== skuId && featureSelectedSkus.includes(id));

      setFeatureSelectedSkus((prev) => prev.filter((item) => item !== skuId));
      if (!remainingSkuIds.length) {
        setFeatureSelectedProducts((prev) =>
          prev.filter((item) => item !== product.id),
        );
      }
      return;
    }

    setFeatureSelectedSkus((prev) => [...prev, skuId]);
    setFeatureSelectedProducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
    setFeatureExpandedProducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
  };

  useEffect(() => {
    const getdata = async () => {
      const getPromotion = await ProductController.getPromotions({
        Authorization: userService.getUser(),
        companyId: userService.getCompID(),
      });
      setpromotions(getPromotion?.data?.activeAndScheduledCampaignsDTO);
      setactiveProm(getPromotion?.data?.activeCampaigns);
      setscheduledProm(getPromotion?.data?.scheduledCampaigns);
    };

    getdata();
  }, []);
  useEffect(() => {
    const getdata = async () => {
      const getFeaturedCategories =
        await ProductController.getFeaturedCategories({
          Authorization: userService.getUser(),
          companyId: userService.getCompID(),
        });
      setfeatures(getFeaturedCategories.data);
    };

    getdata();
  }, []);

  useEffect(() => {
    const getCampaignProductCatalog = async () => {
      if (!selectedCampaignCategoryIds.length) {
        setmockproducts([]);
        setSelectedproducts([]);
        setSelectedskus([]);
        setExpandedproducts([]);
        return;
      }

      try {
        const results = await Promise.all(
          selectedCampaignCategoryIds.map((categoryId) =>
            ProductController.getProductCatalog({
              Authorization: userService.getUser(),
              brand: "",
              categoryId,
              color: "",
              companyID: userService.getCompID(),
              maxPrice: "",
              minPrice: "",
              productCompanyStatus: 1,
              productSystemStatus: 1,
              page: 1,
              search: "",
              size: "",
              sizePage: 1000000,
              sortBy: "",
              sortDirection: "",
            }),
          ),
        );
        const mergedProducts = results
          .flatMap((res) => {
            if (Array.isArray(res?.data)) {
              return res.data;
            }

            if (Array.isArray(res?.data?.rows)) {
              return res.data.rows;
            }

            return [];
          })
          .map((product, productIndex) =>
            normalizeCampaignProduct(product, productIndex),
          );

        const uniqueProducts = Array.from(
          new Map(
            mergedProducts.map((product) => [product.id, product]),
          ).values(),
        );
        setmockproducts(uniqueProducts);
        setSelectedproducts((prev) =>
          prev.filter((productId) =>
            uniqueProducts.some((product) => product.id === productId),
          ),
        );
        setSelectedskus((prev) =>
          prev.filter((skuId) =>
            uniqueProducts.some((product) =>
              product.skus.some((sku) => sku.id === skuId),
            ),
          ),
        );
        setExpandedproducts((prev) =>
          prev.filter((productId) =>
            uniqueProducts.some((product) => product.id === productId),
          ),
        );
      } catch (error) {
        console.error(error);
        setmockproducts([]);
        setSelectedproducts([]);
        setSelectedskus([]);
        setExpandedproducts([]);
      }
    };

    getCampaignProductCatalog();
  }, [selectedCampaignCategoryIdsKey]);

  useEffect(() => {
    const getProductCatalog = async () => {
      if (!featureSelectedCategoryIds?.length) {
        setfeatureMockProducts([]);
        setFeatureSelectedProducts([]);
        setFeatureSelectedSkus([]);
        setFeatureExpandedProducts([]);
        return;
      }

      try {
        const results = await Promise.all(
          featureSelectedCategoryIds.map((categoryId) =>
            ProductController.getProductCatalog({
              Authorization: userService.getUser(),
              brand: "",
              categoryId,
              color: "",
              companyID: userService.getCompID(),
              maxPrice: "",
              minPrice: "",
              productCompanyStatus: 1,
              productSystemStatus: 1,
              page: 1,
              search: "",
              size: "",
              sizePage: 1000000,
              sortBy: "",
              sortDirection: "",
            }),
          ),
        );
        const merged = results
          .flatMap((res) => {
            if (Array.isArray(res?.data)) {
              return res.data;
            }

            if (Array.isArray(res?.data?.rows)) {
              return res.data.rows;
            }

            return [];
          })
          .map((product, productIndex) =>
            normalizeFeatureProduct(product, productIndex),
          );
        const uniqueProducts = Array.from(
          new Map(merged.map((product) => [product.id, product])).values(),
        );

        setfeatureMockProducts(uniqueProducts);
        setFeatureSelectedProducts((prev) =>
          prev.filter((productId) =>
            uniqueProducts.some((product) => product.id === productId),
          ),
        );
        setFeatureSelectedSkus((prev) =>
          prev.filter((skuId) =>
            uniqueProducts.some((product) =>
              product.skus.some((sku) => sku.id === skuId),
            ),
          ),
        );
        setFeatureExpandedProducts((prev) =>
          prev.filter((productId) =>
            uniqueProducts.some((product) => product.id === productId),
          ),
        );
      } catch (err) {
        console.error(err);
        setfeatureMockProducts([]);
        setFeatureSelectedProducts([]);
        setFeatureSelectedSkus([]);
        setFeatureExpandedProducts([]);
      }
    };

    getProductCatalog();
  }, [featureSelectedCategoryIdsKey]);

  const handlecreateCampaign = async () => {
    try {
      const getCampaignsNameAndId =
        await ProductController.getCampaignsNameAndId({
          Authorization: userService.getUser(),
        });
      setCampaignName(getCampaignsNameAndId?.data);
    } catch (error) {}
  };
  const request = {
    campaignName: newCampaignName,
    description: campaignDescription,
  };

  const handleAddCamp = async () => {
    try {
      const addCampaign = await PromotionController.addCampaign({
        Authorization: userService.getUser(),
        request: request,
      });
      if (addCampaign.data) {
        setNewCampaignName("");
        setCampaignDescription("");
        handlecreateCampaign();
        setNewCam(false);
      }
    } catch (error) {}
  };
  const addCampainToProduct = async (status) => {
    const req = {
      campaignsStatus: status,
      categoryId: selectedCampaignCategories.map((category) => category.id),
      companyID: userService.getCompID(),
      description: campaignDescription,
      discountValue: String(discount),
      discountValueType: discountUnit,
      endDate: formatreviewdate(campaignRange.to),
      offerType: offerType,
      productAndSku: {
        productID: selectedproductdetails.map(
          (product) => product.productID ?? product.id,
        ),
        skuId: selectedskus,
      },
      productScope:
        selectedproductdetails.length === 0
          ? "ENTIRE_CATEGORY"
          : "SPECIFIC_PRODUCTS",
      promotionName: categoryFilter,
      startDate: formatreviewdate(campaignRange.from),
    };

    try {
      const addCampaign = await ProductController.addCampaign({
        Authorization: userService.getUser(),
        request: req,
      });
      if (addCampaign.data === true) {
        window.location.reload();
      }
    } catch (error) {}
  };

  function getDurationInDays(from, to) {
    if (!from || !to) return 0;

    const parse = (value) => {
      const [day, month, year] = value.split("/");
      return new Date(Number(year), Number(month) - 1, Number(day));
    };

    const start = parse(from);
    const end = parse(to);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0;

    const diffMs = end - start;

    // convert ms → days
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1;

    return diffDays < 0 ? 0 : diffDays;
  }

  const HandleCreateFeature = async () => {
    const requestDTO = {
      categoryId: featureSelectedCategoryDetails[0]?.id || null,
      creditCostSummary: {
        creditsPerProduct: "40 credits",
        productsSelected: `${featureSelectedProductDetails.length} product${
          featureSelectedProductDetails.length === 1 ? "" : "s"
        }`,
        promotionDuration: getDurationInDays(
          featureRange.from,
          featureRange.to,
        ),
        remainingAfterActivation: `${featureRemainingCredits} credits`,
        totalCreditsRequired: `${featureTotalCreditsRequired} credits`,
      },
      endDate: formatreviewdate(featureRange.to),
      productAndSku: {
        productID: featureSelectedProductDetails.map((product) => product.id),
        skuId: featureSelectedSkuDetails.map((sku) => sku.id),
      },
      startDate: formatreviewdate(featureRange.from),
    };
    try {
      const addFeatured = await PromotionController.addFeatured({
        Authorization: userService.getUser(),
        request: requestDTO,
      });
      if (addFeatured.data === true) {
        window.location.reload();
      }
      if (addFeatured.data !== true) {
        toast.error(addFeatured?.response?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const getBillings = async () => {
      const livePlansResponse = await PromotionController.getAllBillingPlans({
        Authorization: userService.getUser(),
      });
      const livePlans = livePlansResponse?.data || [];

      setRawBillingPlans(livePlans);

      try {
        const response = await PromotionController.getPlansAndBilling({
          Authorization: userService.getUser(),
          companyId: userService.getCompID(),
        });
        const summary = response?.data || null;
        const mergedPlans = mergeBillingPlans(
          summary?.billingPlans || [],
          livePlans,
        );

        setCreditSummary(summary);
        setBillingPlans(mergedPlans);
      } catch (error) {
        setBillingPlans(livePlans);
      }
    };
    getBillings();
  }, []);
  useEffect(() => {
    const plans = Array.isArray(BillingPlans)
      ? BillingPlans
      : Array.isArray(BillingPlans?.data)
        ? BillingPlans.data
        : [];

    if (!plans.length) return;

    const defaultPlan = plans.find((plan) => plan?.mostPopular) || plans[0];

    setSelectedBillingPlanId(
      (prev) => prev || defaultPlan?.billingPlanId || "",
    );
  }, [BillingPlans]);
  useEffect(() => {
    if (isPromotionModalOpen || isFeatureModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isPromotionModalOpen, isFeatureModalOpen]);
  const [succ, setSucc] = useState(false);
  const PurchasePlan = async (plan) => {
    const resolvedPlan = plan?.billingPlanId
      ? plan
      : normalizedRawBillingPlans.find(
          (item) =>
            String(item?.planName || "")
              .trim()
              .toLowerCase() ===
            String(plan?.planName || "")
              .trim()
              .toLowerCase(),
        ) || plan;

    if (!resolvedPlan?.billingPlanId) {
      return;
    }

    const request = {
      billingPlanId: resolvedPlan?.billingPlanId,
      companyId: userService.getCompID(),
      createdById: Utils.parseJwt(userService.getUser()).id,
    };
    try {
      const buyCredits = await PromotionController.buyCredits({
        Authorization: userService.getUser(),
        request: request,
      });

      if (buyCredits?.data) {
        setSucc(true);
        const totalCredits = Number(buyCredits.data.totalCredits ?? 0);
        const usedCredits = Number(buyCredits.data.usedCredits ?? 0);
        const availableCredits = Number(buyCredits.data.availableCredits ?? 0);
        const usedPercentage =
          totalCredits > 0
            ? Math.min((usedCredits / totalCredits) * 100, 100)
            : 0;

        setCreditSummary((prev) => ({
          ...(prev || {}),
          totalCredits,
          usedCredits,
          availableCredits,
          usedPercentage,
        }));
      } else if (
        buyCredits?.response?.data?.message ==
        "No saved payment method found for this user"
      ) {
        toast.error("No saved payment method found for this user");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="promotion-marketing-main-container">
      {succ ? (
        <div className="popup-container">
          <div
            className="popup-content-container"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popup-content">
              <div className="successfully-added-icon">
                <SuccTickIcon />
              </div>
              <div className="successfully-added-text">
                Plan Purchased Successfully
              </div>
              <div
                className="successfully-added-action-button"
                onClick={() => setSucc(false)}
              >
                Continue
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="promotion-marketing-header">
        <div className="promotion-marketing-header-int">
          <div className="promotion-and-managment-icon">
            <PromotionAndMarketing />
          </div>
          <div className="promotion-marketing-header-text">
            <div className="promotion-marketing-header-title">
              Promotions And Marketing
            </div>
            <div className="promotion-marketing-header-note">
              Boost product visibility and clear inventory
            </div>
          </div>
        </div>
        <div className="promotion-and-managment-store-status">
          <div
            className="store-status-text"
            // onClick={() => navigate("/create-campaign")}
            onClick={() => {
              handlecreateCampaign();
              setCurrentCampaignStep(1);
              setIsPromotionModalOpen(true);
            }}
          >
            <div className="plus-icon">
              <PlusIcon fill="#4072c8" />
            </div>
            Create Campaign
          </div>
          <div
            className="create-new-featured-prod"
            onClick={() => {
              setCurrentFeatureStep(1);
              setIsFeatureModalOpen(true);
            }}
          >
            <div className="plus-icon">
              <PlusIcon fill="#4072c8" />
            </div>
            Create Feature
          </div>
        </div>
      </div>
      <div className="promotion-marketing-content-body">
        <div className="promotion-marketing-credits">
          <div className="promotion-marketing-credits-cont">
            <div className="promotion-marketing-credits-data-cridits">
              <div className="promotion-marketing-credits-data">
                <div className="promotion-marketing-credits-label">
                  <CriditsIcon />
                  Available Credits
                </div>
                <div className="promotion-marketing-credits-value">
                  {availableCreditsValue}
                </div>
              </div>
              <div className="promotion-marketing-credits-data-cridits-range">
                <div className="promotion-marketing-credits-data-cridits-range-header">
                  <div className="promotion-marketing-credits-data-cridits-range-title">
                    Used: {used}
                  </div>
                  <div className="promotion-marketing-credits-data-cridits-range-content">
                    {percent}% capacity
                  </div>
                </div>

                <div className="promotion-marketing-credits-data-cridits-range-body">
                  <div
                    className="range-fill"
                    style={{ width: `${percent}%` }}
                  />
                </div>
                {/* <div className="promotion-marketing-credits-data-cridits-range-content">
                  Remaining: {total - used}
                </div> */}
                <div className="promotion-marketing-credits-data-cridits-range-footer">
                  Credits are used when activating campaigns or featured
                  placements.
                </div>
              </div>
            </div>
            {/* <div className="promotion-marketing-credits-action-buttons">
              <div className="promotion-marketing-credits-buy-button">
                View History
              </div>
              <div className="promotion-marketing-credits-view-button">
                Buy Credits
              </div>
            </div> */}
          </div>
        </div>
        <div className="promotion-marketing-nav">
          <div className="promotion-marketing-nav-section">
            <div
              className={rowClass("active-promotions")}
              onClick={() => setActive("active-promotions")}
            >
              Active Promotions
            </div>
            <div
              className={rowClass("create-campaign")}
              onClick={() => setActive("create-campaign")}
            >
              Featured Placements
            </div>
            <div
              className={rowClass("featured-placements")}
              onClick={() => setActive("featured-placements")}
            >
              Plans & Billing
            </div>
          </div>
        </div>
        <div className="promotion-marketing-body-container">
          {active === "active-promotions" && (
            <div className="promotion-marketing-promotion-list">
              {!promotions || promotions?.length === 0 ? null : (
                <div className="promotion-marketing-promotion-list-header">
                  <div className="promotion-marketing-promotion-list-title">
                    <div className="active-promotion-marketing-searchbar">
                      <SearchIcon />
                      <input
                        placeholder="Search campaigns..."
                        className="active-promotion-marketing-searchbar-input"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                      ></input>
                    </div>

                    <div className="search-campain-filter-section">
                      <CustomDropdown
                        rightIcon={<ArrowDownIcon />}
                        value={statusFilter}
                        onChange={setStatusFilter}
                        placeholder="Status"
                        options={[
                          { label: "All Status", value: "ALL_STATUS" },
                          { label: "Active", value: "ACTIVE" },
                          { label: "Scheduled", value: "UPCOMING" },
                        ]}
                        className="active-promotion-marketing-status"
                        openClassName="promotion-marketing-create-body-content-drop-menu-open"
                        menuClassName="status-drop-menu-container"
                        optionClassName="catagory-status-drop-menu-option"
                      />
                      <div className="active-promotion-marketing-filter">
                        <div className="user-management-filter-content">
                          <div className="user-management-filter-icon">
                            <FilterIcon />
                          </div>
                          <div className="user-management-filter-text">
                            Filter
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="promotion-marketing-promotion-list-stats">
                    <div className="promotion-marketing-promotion-stat">
                      {activeProm}
                    </div>
                    <div className="promotion-marketing-promotion-stat-dot"></div>
                    <div className="promotion-marketing-promotion-stats">
                      {scheduledProm}
                    </div>
                  </div>
                </div>
              )}

              <div className="promotion-marketing-promotion-list-cards">
                {!filteredPromotions.length ? (
                  <div className="no-active-promotions">
                    <div className="no-active-promotions-icon">
                      <StarIcon />
                    </div>
                    <div className="no-active-promotions-text">
                      {promotions?.length
                        ? "No promotions match your search or status filter."
                        : "No Active Promotions"}
                    </div>
                  </div>
                ) : (
                  <div className="promotion-list">
                    {filteredPromotions.map((promotion, index) => (
                      <div
                        key={promotion.id ?? index}
                        className="promotion-marketing-promotion-card"
                        // key={promotion.id}
                        // onClick={() => navigate("/active-promotion")}
                      >
                        <div className="promotion-marketing-promotion-card-header">
                          <div className="promotion-marketing-promotion-card-icon">
                            <PromotionAndMarketing stroke="#424242" />
                          </div>
                          <div
                            className="promoyion-card-action-center"
                            ref={
                              PromotionVeiw === index ? PromotionVeiwRef : null
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              setPromotionVeiw((prev) =>
                                prev === index ? null : index,
                              );
                            }}
                          >
                            <ThreeDots />
                            {PromotionVeiw === index ? (
                              <div className="feature-details-pop">
                                <div
                                  className="feature-details-pop-row"
                                  onClick={() => {
                                    openPromotionDetails(
                                      "view",
                                      promotion.productOfferId,
                                    );
                                  }}
                                >
                                  <EyeViewOpened /> View Details
                                </div>
                                <div
                                  className="feature-details-pop-row"
                                  onClick={() =>
                                    openPromotionDetails(
                                      "edit",
                                      promotion.productOfferId,
                                    )
                                  }
                                >
                                  <PensilIcon Strock="#424242" />
                                  Edit Details
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>

                        <div className="promotion-marketing-promotion-card-badges">
                          <div className="promotion-marketing-promotion-card-type">
                            {getPromotionCategoryNames(promotion).join(", ") ||
                              "Uncategorized"}
                          </div>
                          <div
                            className={`promotion-marketing-promotion-card-status-${promotion.campaignsStatus.toLowerCase()}`}
                          >
                            {promotion.campaignsStatus}
                          </div>
                        </div>

                        <div className="promotion-marketing-promotion-card-text">
                          <div className="promotion-marketing-promotion-card-title">
                            {promotion.title}
                          </div>
                          <div className="promotion-marketing-promotion-card-description">
                            {promotion.description}
                          </div>
                        </div>

                        <div className="promotion-marketing-promotion-card-divider"></div>

                        <div className="promotion-marketing-promotion-card-meta">
                          <div className="promotion-marketing-promotion-card-meta-item">
                            <div className="promotion-marketing-promotion-card-meta-label">
                              <ProductManagmentIcon /> Category
                            </div>
                            <div className="promotion-marketing-promotion-card-meta-value">
                              {getPromotionCategoryNames(promotion).join(
                                ", ",
                              ) || "Uncategorized"}
                            </div>
                          </div>

                          <div className="promotion-marketing-promotion-card-meta-item">
                            <div className="promotion-marketing-promotion-card-meta-label">
                              <DiscountIcon /> Discount
                            </div>
                            <div className="promotion-marketing-promotion-card-meta-value">
                              {promotion.discountApplied}
                            </div>
                          </div>
                        </div>

                        <div className="promotion-marketing-promotion-card-date-pill">
                          <DateIcon />
                          <div className="promotion-marketing-promotion-card-date-text">
                            {formatDate(promotion.startDate)}-
                            {formatDate(promotion.endDate)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
          {active === "create-campaign" && (
            <div className="promotion-marketing-promotion-list">
              <div className="promotion-marketing-promotion-list-cards">
                {!features || features?.length === 0 ? (
                  <div className="no-active-promotions">
                    <div className="no-active-promotions-icon">
                      <StarIcon />
                    </div>
                    <div className="no-active-promotions-text">
                      No Featured Placements <br />
                      <span className="no-feature-note">
                        Showcase your products on the Azalea marketplace
                        homepage. Create <br />
                        your first featured placement to boost visibility and
                        drive sales.
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="promotion-list">
                    {features?.map((promotion, index) => (
                      <div
                        className="feature-marketing-promotion-card"
                        key={promotion.productOfferId ?? index}
                        // onClick={() => navigate("/active-promotion")}
                      >
                        <div className="feature-card-header">
                          <div className="feature-card-header-main">
                            <div className="feature-card-title-wrap">
                              <div className="feature-card-title-text">
                                Category
                              </div>
                            </div>
                            <div
                              className="feature-details-trigger"
                              style={{ width: "15px" }}
                              ref={
                                FeatureView === index ? featureViewRef : null
                              }
                              onClick={() =>
                                setFeatureView((prev) =>
                                  prev === index ? null : index,
                                )
                              }
                            >
                              <div className="feature-card-menu-dots">...</div>
                              {FeatureView === index ? (
                                <div className="feature-details-pop">
                                  <div
                                    className="feature-details-pop-row"
                                    onClick={() =>
                                      openFeaturedPlacement(
                                        "view",
                                        promotion.productOfferId,
                                      )
                                    }
                                  >
                                    View Details
                                  </div>
                                  {/* <div
                                    className="feature-details-pop-row"
                                    onClick={() =>
                                      openFeaturedPlacement(
                                        "edit",
                                        promotion.productOfferId,
                                      )
                                    }
                                  >
                                    Edit Details
                                  </div> */}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="features-card-data">
                          {getFeaturedCategoryNames(promotion).length ? (
                            getFeaturedCategoryNames(promotion).map(
                              (categoryName, index) => (
                                <div
                                  key={index}
                                  className="features-card-categories"
                                >
                                  {categoryName}
                                </div>
                              ),
                            )
                          ) : (
                            <div className="features-card-categories">
                              Uncategorized
                            </div>
                          )}
                          <div className="feature-card-products-list">
                            {(Array.isArray(
                              promotion?.products?.[0]?.productName,
                            )
                              ? promotion.products[0].productName
                              : []
                            )
                              .filter(Boolean)
                              .slice(0, 2)
                              .map((item, itemIndex) => (
                                <div
                                  key={`${promotion.productOfferId ?? index}-${itemIndex}`}
                                  className="feature-card-product-item"
                                >
                                  <div className="feature-card-product-bullet">
                                    •
                                  </div>
                                  <div className="feature-card-product-text">
                                    {item}
                                  </div>
                                </div>
                              ))}
                            {!(
                              Array.isArray(
                                promotion?.products?.[0]?.productName,
                              )
                                ? promotion.products[0].productName
                                : []
                            ).filter(Boolean).length ? (
                              <div className="feature-card-product-empty">
                                No products available
                              </div>
                            ) : null}
                          </div>
                          <div className="features-card-data-date">
                            <div className="feature-card-date-text">
                              {promotion?.products?.[0]?.startDate &&
                              promotion?.products?.[0]?.endDate
                                ? `${promotion.products[0].startDate} - ${promotion.products[0].endDate}`
                                : "No date range"}
                            </div>
                          </div>
                          <div className="features-card-data-credits">
                            <div className="features-card-data-credits-label">
                              Credits Used
                            </div>
                            <div className="features-card-data-credits-value">
                              {promotion?.products?.[0]?.creditsUsed ??
                                promotion?.availableCredits ??
                                "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
          {active === "featured-placements" && (
            <div className="plans-and-billing-container">
              <div className="plans-and-billing-container-header">
                <div className="plans-and-billing-container-title">
                  Supercharge Your Sales
                </div>
                <div className="plans-and-billing-container-note">
                  Purchase credits to unlock powerful promotional tools and
                  increase your
                  <br className="mobile-break" /> store's visibility.
                </div>
              </div>
              <div className="plans-and-billing-container-body">
                {normalizedBillingPlans.map((plan, index) => {
                  const isHighlighted =
                    selectedBillingPlanId === plan?.billingPlanId;

                  return (
                    <div
                      key={plan?.billingPlanId || plan?.planName || index}
                      className={`plans-and-billing-container-body-card${
                        isHighlighted
                          ? " plans-and-billing-container-body-card-featured"
                          : ""
                      }`}
                      onClick={() =>
                        setSelectedBillingPlanId(plan?.billingPlanId || "")
                      }
                    >
                      <div className="plans-and-billing-card-data-container">
                        <div className="plans-and-billing-card-data">
                          <div className="plans-and-billing-card-data-header">
                            <div className="plans-and-billing-card-data-header-cont">
                              <div className="growth-boost-icon-box">
                                {getBillingPlanIcon(plan?.planName, index)}
                              </div>
                              {plan?.mostPopular ? (
                                <div className="most-popular-campaign">
                                  Most Popular
                                </div>
                              ) : null}
                            </div>
                            <div className="plans-and-billing-card-data-title">
                              {plan?.planName}
                            </div>
                            <div className="plans-and-billing-card-data-note">
                              {plan?.description}
                            </div>
                          </div>
                          <div className="plans-and-billing-card-data-pricing">
                            <div className="plans-and-billing-card-data-pricing-monthly">
                              <div className="plans-and-billing-card-data-pricing-amount">
                                ${plan?.price}
                              </div>
                              <div className="plans-and-billing-card-data-pricing-duration">
                                / {plan?.durationInDays} days
                              </div>
                            </div>
                            <div className="plans-and-billing-card-data-pricing-cridits">
                              {plan?.creditsIncluded} Credits Included
                            </div>
                          </div>
                          <div className="plans-and-billing-card-data-qualifications">
                            {(Array.isArray(plan?.billingPlansDetails)
                              ? plan.billingPlansDetails
                              : Array.isArray(plan?.features)
                                ? plan.features
                                : []
                            ).map((detail, detailIndex) => (
                              <div
                                key={`${plan?.billingPlanId || index}-${detailIndex}`}
                                className="plans-and-billing-card-data-qualifications-rows"
                              >
                                <input
                                  type="checkbox"
                                  className="plans-and-billing-checkbox"
                                  checked
                                  disabled
                                  readOnly
                                />
                                {detail}
                              </div>
                            ))}
                          </div>
                        </div>
                        <div
                          className={`plans-and-billing-card-data-button${
                            isHighlighted
                              ? " plans-and-billing-card-data-button-featured"
                              : ""
                          }`}
                          onClick={() => PurchasePlan(plan)}
                        >
                          {formatBillingButtonLabel(plan?.planName)}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      {isPromotionModalOpen && (
        <div
          className="promotion-marketing-modal-overlay"
          onClick={() => setIsPromotionModalOpen(false)}
        >
          <div
            className="promotion-marketing-modal-shell"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="create-campain-cont-container-header">
              <div className="create-campain-cont-container">
                <div className="create-campain-cont-container-title">
                  Create Campaign
                  <div
                    className="close-popup"
                    onClick={() => {
                      setIsPromotionModalOpen(false);
                      setCategoryFilter("");
                      setCategoryFilterID("");
                      setCampaignDescription("");
                      setOfferType("");
                      setSelectedcategories([]);
                      setdiscount("");
                      setCampaignRange({ from: "", to: "" });
                    }}
                  >
                    <XIcon stroke="#667085" />
                  </div>
                </div>
                <div className="create-campain-cont-container-steps">
                  {campaignSteps.map((step, index) => {
                    const isCompleted = currentCampaignStep > step.id;
                    const isActive = currentCampaignStep === step.id;

                    return (
                      <React.Fragment key={step.id}>
                        <div
                          className={`create-campain-step-item${
                            isActive ? " create-campain-step-item-active" : ""
                          }${
                            isCompleted
                              ? " create-campain-step-item-completed"
                              : ""
                          }`}
                        >
                          <div className="create-campain-step-number">
                            {isCompleted ? "✓" : step.id}
                          </div>
                          <div className="create-campain-step-label">
                            {step.label}
                          </div>
                        </div>
                        {index < campaignSteps.length - 1 && (
                          <div
                            className={`create-campain-step-line${
                              currentCampaignStep > step.id
                                ? " create-campain-step-line-completed"
                                : ""
                            }`}
                          ></div>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="create-campain-cont-containerbody">
              <div className="create-campain-cont-container-data create-campain-step-panel">
                <div className="create-campain-step-panel-header">
                  {/* <div className="create-campain-step-panel-title">
                    {currentCampaignStepData.label}
                  </div> */}
                </div>
                <div className="create-campain-step-panel-body">
                  <div
                    className={`create-campain-step-panel-content${
                      currentCampaignStep === 1
                        ? " create-campain-step-panel-content-active"
                        : ""
                    }`}
                  >
                    <div className="fisrt-step-campaign-container">
                      <div className="fisrt-step-create-campaign">
                        <div className="fisrt-step-create-campaign-title">
                          Campaign Name
                        </div>

                        <div className="fisrt-step-create-campaign-body">
                          <CustomDropdown
                            searchable
                            rightIcon={<ArrowDownIcon />}
                            value={categoryFilterID}
                            onChange={handleCampaignSelect}
                            placeholder="Select campaign"
                            options={campaignOptions}
                            className="select-campaign-menu"
                            openClassName="promotion-marketing-create-body-content-drop-menu-open"
                            menuClassName="camp-name-drop-menu-container"
                            optionClassName="catagory-status-drop-menu-option"
                          />
                          <div
                            style={{
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => setNewCam(true)}
                          >
                            <PlusIcon fill="#4072C8" />
                          </div>
                        </div>
                      </div>
                      {/* <div className="fisrt-step-create-campaign">
                        <div className="fisrt-step-create-campaign-title">
                          Short Description
                        </div>
                        <div className="fisrt-step-create-campaign-body">
                          <textarea
                            className="create-campan-short-discription"
                            placeholder="Describe your campaign..."
                            value={campaignDescription}
                            onChange={(e) =>
                              setCampaignDescription(e.target.value)
                            }
                          ></textarea>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div
                    className={`create-campain-step-panel-content${
                      currentCampaignStep === 2
                        ? " create-campain-step-panel-content-active"
                        : ""
                    }`}
                  >
                    <div className="campaign-products-step">
                      <div className="campaign-products-toprow">
                        <div className="campaign-products-filterlabel">
                          Filter by Categories
                        </div>
                        <div
                          className="campaign-products-filterbutton"
                          onClick={() => setShowcategoryfilter((prev) => !prev)}
                        >
                          Filter Categories
                        </div>
                      </div>
                      {showcategoryfilter ? (
                        <div className="campaign-products-block">
                          <div className="campaign-products-filterpanel">
                            <div className="campaign-products-filtersearch">
                              <input
                                type="text"
                                className="campaign-products-filterinput"
                                placeholder="Search categories..."
                                value={categorysearch}
                                onChange={(e) =>
                                  setCategorysearch(e.target.value)
                                }
                              />
                            </div>
                            <div className="campaign-products-filterlist">
                              {filteredcategoryoptions.map((category) => {
                                const isselected = selectedcategories.includes(
                                  category.id,
                                );

                                return (
                                  <div
                                    key={category.id}
                                    className={`campaign-products-category${
                                      isselected
                                        ? " campaign-products-category-active"
                                        : ""
                                    }`}
                                    onClick={() =>
                                      handleCampaignCategoryToggle(category)
                                    }
                                  >
                                    <div className="campaign-products-category-marker">
                                      <div className="campaign-products-category-dot"></div>
                                    </div>

                                    <div className="campaign-products-category-text">
                                      {category.name}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className="campaign-products-selected">
                            <div className="campaign-products-selected-tags">
                              {selectedcategories.length ? (
                                selectedcategories.map((id) => {
                                  const category = uniqueCategories.find(
                                    (c) => c.id === id,
                                  );

                                  return (
                                    <div
                                      key={id}
                                      className="campaign-products-selected-tag"
                                      onClick={() =>
                                        handleCampaignCategoryToggle(category)
                                      }
                                    >
                                      {category?.name || "Unknown"} ×
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="campaign-products-empty">
                                  Choose at least one category to continue
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="campaign-products-placeholder"></div>
                      )}
                      {showcategoryfilter && selectedcategories.length ? (
                        <div className="campaign-products-block">
                          <div className="campaign-products-block-head">
                            <div className="campaign-products-title">
                              Select Products & SKUs
                            </div>
                            <div className="campaign-products-summary">
                              Select categories above to filter products
                            </div>
                          </div>
                          <div className="campaign-products-panel">
                            <div className="campaign-products-filtersearch">
                              <input
                                type="text"
                                className="campaign-products-filterinput"
                                placeholder="Search products or SKUs..."
                                value={productsearch}
                                onChange={(e) =>
                                  setProductsearch(e.target.value)
                                }
                              />
                            </div>
                            <div className="campaign-products-list">
                              {visibleproducts.length ? (
                                visibleproducts.map((product) => {
                                  const isselected = selectedproducts.includes(
                                    product.id,
                                  );
                                  const isexpanded = expandedproducts.includes(
                                    product.id,
                                  );
                                  const selectedcount = product.skus.filter(
                                    (sku) => selectedskus.includes(sku.id),
                                  ).length;

                                  return (
                                    <div
                                      key={product.id}
                                      className={`campaign-products-product${
                                        isselected
                                          ? " campaign-products-product-active"
                                          : ""
                                      }`}
                                    >
                                      <div
                                        className="campaign-products-item"
                                        onClick={() => {
                                          handleCampaignProductToggle(product);
                                        }}
                                      >
                                        <div className="campaign-products-item-checkbox">
                                          <div
                                            className={`campaign-products-item-checkbox-inner${
                                              isselected
                                                ? " campaign-products-item-checkbox-inner-active"
                                                : ""
                                            }`}
                                          ></div>
                                        </div>
                                        <div className="campaign-products-item-avatar">
                                          {product.name.slice(0, 1)}
                                        </div>
                                        <div className="campaign-products-item-info">
                                          <div className="campaign-products-item-name">
                                            {product.name}
                                          </div>
                                          <div className="campaign-products-item-meta">
                                            {product.skus.length} variants
                                            available
                                            {selectedcount
                                              ? ` • ${selectedcount} selected`
                                              : ""}
                                          </div>
                                        </div>
                                        <div
                                          className={`campaign-products-item-arrow${
                                            isexpanded
                                              ? " campaign-products-item-arrow-open"
                                              : ""
                                          }`}
                                        >
                                          <ArrowDownIcon />
                                        </div>
                                      </div>
                                      {isexpanded ? (
                                        <div className="campaign-products-skulist">
                                          {product.skus.length ? (
                                            product.skus.map((sku) => {
                                              const isskuselected =
                                                selectedskus.includes(sku.id);

                                              return (
                                                <div
                                                  key={sku.id}
                                                  className="campaign-products-skuitem"
                                                  onClick={() =>
                                                    handleCampaignSkuToggle(
                                                      product,
                                                      sku.id,
                                                    )
                                                  }
                                                >
                                                  <div className="campaign-products-skucheck">
                                                    <div
                                                      className={`campaign-products-skucheckinner${
                                                        isskuselected
                                                          ? " campaign-products-skucheckinner-active"
                                                          : ""
                                                      }`}
                                                    ></div>
                                                  </div>
                                                  <div className="campaign-products-skuinfo">
                                                    <div className="campaign-products-skuname">
                                                      {sku.color}
                                                    </div>
                                                    <div className="campaign-products-skucode">
                                                      {sku.code}
                                                    </div>
                                                  </div>
                                                  <div className="campaign-products-skustock">
                                                    Stock {sku.stock}
                                                  </div>
                                                </div>
                                              );
                                            })
                                          ) : (
                                            <div className="campaign-products-empty">
                                              No SKUs found for this product
                                            </div>
                                          )}
                                        </div>
                                      ) : null}
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="campaign-products-empty">
                                  No products found for the selected categories
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="campaign-products-selectionsummary">
                            <div className="campaign-products-selectionsummary-count">
                              {selectedskudetails.length} SKUs selected
                            </div>
                            <div className="campaign-products-selectionsummary-meta">
                              From {selectedproductdetails.length} product
                              {selectedproductdetails.length === 1 ? "" : "s"}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div
                    className={`create-campain-step-panel-content${
                      currentCampaignStep === 3
                        ? " create-campain-step-panel-content-active"
                        : ""
                    }`}
                  >
                    <div className="campaign-discount-step">
                      <div className="campaign-discount-row">
                        <div className="campaign-discount-label">
                          Discount Value
                        </div>
                        <div className="campaign-discount-input-row">
                          <input
                            type="text"
                            inputMode="decimal"
                            className="campaign-discount-input"
                            placeholder="0"
                            value={discount}
                            onChange={(e) => {
                              const value = e.target.value;

                              if (/^\d*$/.test(value)) {
                                setdiscount(value);
                              }
                            }}
                          />
                          <div className="campaign-discount-unit-switch">
                            <div
                              className={`campaign-discount-unit${
                                discountUnit === "PERCENTAGE" || !discountUnit
                                  ? " campaign-discount-unit-active"
                                  : ""
                              }`}
                              onClick={() => setDiscountUnit("PERCENTAGE")}
                            >
                              %
                            </div>
                            <div
                              className={`campaign-discount-unit${
                                discountUnit === "VALUE"
                                  ? " campaign-discount-unit-active"
                                  : ""
                              }`}
                              onClick={() => setDiscountUnit("VALUE")}
                            >
                              $
                            </div>
                          </div>
                        </div>
                        <div className="campaign-discount-note">
                          Choose `%` for percentage discounts or `$` for a fixed
                          amount off.
                        </div>
                      </div>
                      <div className="campaign-discount-row">
                        <DateRangePicker
                          fromValue={campaignRange.from}
                          toValue={campaignRange.to}
                          onRangeChange={setCampaignRange}
                          compact
                          fromLabel="Start Date"
                          toLabel="End Date"
                          className="campaign-discount-range"
                          inputsClassName="campaign-discount-range-inputs"
                          inputColClassName="campaign-discount-range-col"
                          fieldClassName="campaign-discount-range-field"
                          popoverClassName="campaign-discount-range-popover"
                          calendarCardClassName="campaign-discount-range-card"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`create-campain-step-panel-content${
                      currentCampaignStep === 4
                        ? " create-campain-step-panel-content-active"
                        : ""
                    }`}
                  >
                    <div className="campaign-review-step">
                      <div className="campaign-review-card">
                        <div className="campaign-review-card-title">
                          Campaign Summary
                        </div>
                        <div className="campaign-review-section">
                          <div className="campaign-review-label">
                            Campaign Name
                          </div>
                          <div className="campaign-review-value">
                            {categoryFilter || "No campaign selected"}
                          </div>
                        </div>
                        <div className="campaign-review-section">
                          <div className="campaign-review-label">
                            Description
                          </div>
                          <div className="campaign-review-description">
                            {campaignDescription || "No description added yet"}
                          </div>
                        </div>
                        <div className="campaign-review-section">
                          <div className="campaign-review-label">Category</div>
                          <div className="campaign-review-tags">
                            {selectedCampaignCategories.length ? (
                              selectedCampaignCategories.map((category) => (
                                <div
                                  key={category.id}
                                  className="campaign-review-tag"
                                >
                                  {category.name}
                                </div>
                              ))
                            ) : (
                              <div className="campaign-review-tag">General</div>
                            )}
                          </div>
                        </div>
                        <div className="campaign-review-section">
                          <div className="campaign-review-label">
                            Selected Products & SKUs
                          </div>
                          <div className="campaign-review-value">
                            {selectedproductdetails.length
                              ? `${selectedproductdetails.length} products selected`
                              : "No products selected"}
                          </div>
                          <div className="campaign-review-description">
                            {selectedproductdetails.length
                              ? selectedproductdetails
                                  .map(
                                    (product) =>
                                      `${product.name} (${product.skus.length} SKUs)`,
                                  )
                                  .join(", ")
                              : "Choose products in step 2 to see them here"}
                          </div>
                        </div>
                        <div className="campaign-review-section">
                          <div className="campaign-review-label">Discount</div>
                          <div className="campaign-review-value">
                            {discount
                              ? `${discount}${discountUnit === "PERCENTAGE" ? "%" : "$" || "%"}`
                              : "No discount selected"}
                          </div>
                        </div>
                        <div className="campaign-review-section">
                          <div className="campaign-review-label">
                            Campaign Duration
                          </div>
                          <div className="campaign-review-value">
                            {reviewduration}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="create-campain-cont-container-footer">
              <div
                className={`create-campain-footer-button create-campain-footer-button-back${
                  isFirstCampaignStep
                    ? " create-campain-footer-button-disabled"
                    : ""
                }`}
                onClick={() => {
                  if (!isFirstCampaignStep) {
                    setCurrentCampaignStep((prev) => prev - 1);
                  }
                }}
              >
                <div className="create-campain-footer-button-icon">
                  <ArrowBackIcon />
                </div>
                <div className="create-campain-footer-button-text">Back</div>
              </div>
              {isLastCampaignStep ? (
                <div className="create-campain-footer-review-actions">
                  <div className="create-campain-footer-button create-campain-footer-button-draft">
                    <div
                      className="create-campain-footer-button-text"
                      onClick={() => {
                        const status = "DRAFT";
                        addCampainToProduct(status);
                      }}
                    >
                      Save as Draft
                    </div>
                  </div>
                  <div className="create-campain-footer-button create-campain-footer-button-next">
                    <div
                      className="create-campain-footer-button-text"
                      onClick={() => {
                        const status = "SCHEDULED";
                        addCampainToProduct(status);
                      }}
                    >
                      Activate Campaign
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`create-campain-footer-button create-campain-footer-button-next${
                    isLastCampaignStep
                      ? " create-campain-footer-button-disabled"
                      : ""
                  }`}
                  onClick={() => {
                    if (!isLastCampaignStep) {
                      setCurrentCampaignStep((prev) => prev + 1);
                    }
                  }}
                >
                  <div className="create-campain-footer-button-text">Next</div>
                  <div className="create-campain-footer-button-icon">
                    <ArrowFront />
                  </div>
                </div>
              )}
            </div>
          </div>
          {NewCam ? (
            <div
              className="create-new-cam-layer"
              onClick={() => {
                setNewCam(false);
                setNewCampaignName("");
              }}
            >
              <div
                className="create-new-cam-name"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="create-new-cam-header">
                  <div className="create-new-cam-title">Add New Campaign</div>
                  <button
                    type="button"
                    className="create-new-cam-close"
                    onClick={() => {
                      setNewCam(false);
                      setNewCampaignName("");
                    }}
                  >
                    ×
                  </button>
                </div>
                <div className="create-new-cam-divider"></div>
                <div className="create-new-cam-body">
                  <input
                    type="text"
                    className="create-new-cam-input"
                    placeholder="Type Campaign Name"
                    value={newCampaignName}
                    onChange={(e) => setNewCampaignName(e.target.value)}
                  />
                  <div className="fisrt-step-create-campaign-body">
                    <textarea
                      className="create-campan-short-discription"
                      placeholder="Describe your campaign..."
                      value={campaignDescription}
                      onChange={(e) => setCampaignDescription(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="create-new-cam-actions">
                    <button
                      type="button"
                      className="create-new-cam-button create-new-cam-button-primary"
                      onClick={() => {
                        handleAddCamp();
                      }}
                    >
                      Add
                    </button>
                    <button
                      type="button"
                      className="create-new-cam-button create-new-cam-button-secondary"
                      onClick={() => {
                        setNewCam(false);
                        setNewCampaignName("");
                        setCampaignDescription("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
      {isFeatureModalOpen && (
        <div
          className="promotion-marketing-modal-overlay"
          onClick={() => setIsFeatureModalOpen(false)}
        >
          <div
            className="promotion-marketing-modal-shell promotion-marketing-modal-shell-feature"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="create-campain-cont-container-header create-feature-cont-container-header">
              <div className="create-campain-cont-container">
                <div className="create-campain-cont-container-title">
                  Create Feature
                  <div
                    className="close-popup"
                    onClick={() => {
                      setIsFeatureModalOpen(false);
                      setFeatureRange({ from: "", to: "" });
                      setFeatureSelectedCategories([]);
                    }}
                  >
                    <XIcon stroke="#667085" />
                  </div>
                </div>
                <div className="create-campain-cont-container-steps create-feature-cont-container-steps">
                  {featureSteps.map((step, index) => {
                    const isCompleted = currentFeatureStep > step.id;
                    const isActive = currentFeatureStep === step.id;

                    return (
                      <React.Fragment key={step.id}>
                        <div
                          className={`create-campain-step-item${
                            isActive ? " create-campain-step-item-active" : ""
                          }${
                            isCompleted
                              ? " create-campain-step-item-completed"
                              : ""
                          }`}
                        >
                          <div className="create-campain-step-number">
                            {isCompleted ? "✓" : step.id}
                          </div>
                          <div className="create-campain-step-label">
                            {step.label}
                          </div>
                        </div>
                        {index < featureSteps.length - 1 && (
                          <div
                            className={`create-campain-step-line${
                              currentFeatureStep > step.id
                                ? " create-campain-step-line-completed"
                                : ""
                            }`}
                          ></div>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="create-campain-cont-containerbody create-feature-cont-containerbody">
              <div className="create-campain-cont-container-data create-campain-step-panel">
                <div className="create-campain-step-panel-body">
                  <div
                    className={`create-campain-step-panel-content${
                      currentFeatureStep === 1
                        ? " create-campain-step-panel-content-active"
                        : ""
                    }`}
                  >
                    <div className="feature-duration-step">
                      <DateRangePicker
                        fromValue={featureRange.from}
                        toValue={featureRange.to}
                        onRangeChange={setFeatureRange}
                        compact
                        fromLabel="Start Date"
                        toLabel="End Date"
                        className="feature-duration-range"
                        inputsClassName="feature-duration-range-inputs"
                        inputColClassName="feature-duration-range-col"
                        fieldClassName="feature-duration-range-field"
                        popoverClassName="feature-duration-range-popover"
                        calendarCardClassName="feature-duration-range-card"
                      />
                    </div>
                  </div>
                  <div
                    className={`create-campain-step-panel-content${
                      currentFeatureStep === 2
                        ? " create-campain-step-panel-content-active"
                        : ""
                    }`}
                  >
                    <div className="feature-products-step">
                      <div className="feature-products-toprow">
                        <div className="feature-products-filterlabel">
                          Filter by Categories
                        </div>
                        <div
                          className={`feature-products-filterbutton${
                            featureShowCategoryFilter &&
                            featureSelectedCategories.length
                              ? " feature-products-filterbutton-active"
                              : ""
                          }`}
                          onClick={() =>
                            setFeatureShowCategoryFilter((prev) => !prev)
                          }
                        >
                          {featureSelectedCategories.length
                            ? `${featureSelectedCategories.length} Selected`
                            : "Filter Categories"}
                        </div>
                      </div>
                      {featureShowCategoryFilter ? (
                        <div className="feature-products-block">
                          <div className="feature-products-filterpanel">
                            <div className="feature-products-searchshell">
                              <div className="feature-products-searchicon">
                                <SearchIcon />
                              </div>
                              <input
                                type="text"
                                className="feature-products-searchinput"
                                placeholder="Search categories..."
                                value={featureCategorySearch}
                                onChange={(e) =>
                                  setFeatureCategorySearch(e.target.value)
                                }
                              />
                            </div>
                            <div className="feature-products-filterlist">
                              {featureFilteredCategoryOptions.map(
                                (category) => {
                                  const isselected =
                                    featureSelectedCategories.includes(
                                      category.id,
                                    );

                                  return (
                                    <div
                                      key={category.id}
                                      className={`feature-products-category${
                                        isselected
                                          ? " feature-products-category-active"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        handleFeatureCategoryToggle(category)
                                      }
                                    >
                                      <div className="feature-products-category-check">
                                        <div
                                          className={`feature-products-category-checkinner${
                                            isselected
                                              ? " feature-products-category-checkinner-active"
                                              : ""
                                          }`}
                                        ></div>
                                      </div>

                                      <div className="feature-products-category-name">
                                        {category.name}
                                      </div>
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          </div>
                          <div className="feature-products-selected-tags">
                            {featureSelectedCategories?.length ? (
                              featureSelectedCategories?.map((id) => {
                                const category = featureCategoryOptions.find(
                                  (c) => c.id === id,
                                );

                                return (
                                  <div
                                    key={id}
                                    className="feature-products-selected-tag"
                                    onClick={() =>
                                      handleFeatureCategoryToggle(category)
                                    }
                                  >
                                    {category?.name}
                                    <span className="feature-products-selected-tag-close">
                                      ×
                                    </span>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="feature-products-empty">
                                Choose at least one category to continue
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="feature-products-placeholder"></div>
                      )}
                      {featureShowCategoryFilter &&
                      featureSelectedCategories.length ? (
                        <div className="feature-products-block">
                          <div className="feature-products-block-head">
                            <div className="feature-products-title">
                              Select Products & SKUs
                              <span className="feature-products-title-note">
                                (Select categories above to filter products)
                              </span>
                            </div>
                          </div>
                          <div className="feature-products-panel">
                            <div className="feature-products-searchshell feature-products-searchshell-products">
                              <div className="feature-products-searchicon">
                                <SearchIcon />
                              </div>
                              <input
                                type="text"
                                className="feature-products-searchinput"
                                placeholder="Search products or SKUs..."
                                value={featureProductSearch}
                                onChange={(e) =>
                                  setFeatureProductSearch(e.target.value)
                                }
                              />
                            </div>
                            <div className="feature-products-list">
                              {visibleFeatureProducts.map((product) => {
                                const isselected =
                                  featureSelectedProducts.includes(product.id);
                                const isexpanded =
                                  featureExpandedProducts.includes(product.id);
                                const selectedcount = product.skus.filter(
                                  (sku) => featureSelectedSkus.includes(sku.id),
                                ).length;

                                return (
                                  <div
                                    key={product.id}
                                    className={`feature-products-product${
                                      isselected
                                        ? " feature-products-product-active"
                                        : ""
                                    }`}
                                  >
                                    <div
                                      className="feature-products-item"
                                      onClick={() => {
                                        handleFeatureProductToggle(product);
                                      }}
                                    >
                                      <div className="feature-products-item-checkbox">
                                        <div
                                          className={`feature-products-item-checkbox-inner${
                                            isselected
                                              ? " feature-products-item-checkbox-inner-active"
                                              : ""
                                          }`}
                                        ></div>
                                      </div>
                                      <div className="feature-products-item-avatar">
                                        {product.image ? (
                                          <img
                                            src={product.image}
                                            alt={product.name}
                                            className="feature-products-item-image"
                                          />
                                        ) : (
                                          product.name.slice(0, 1)
                                        )}
                                      </div>
                                      <div className="feature-products-item-info">
                                        <div className="feature-products-item-name">
                                          {product.name}
                                        </div>
                                        <div className="feature-products-item-meta">
                                          {product.skus.length} variants
                                          available
                                          {selectedcount
                                            ? ` • ${selectedcount} selected`
                                            : ""}
                                        </div>
                                      </div>
                                      <div
                                        className={`feature-products-item-arrow${
                                          isexpanded
                                            ? " feature-products-item-arrow-open"
                                            : ""
                                        }`}
                                      >
                                        <ArrowDownIcon />
                                      </div>
                                    </div>
                                    {isexpanded ? (
                                      <div className="feature-products-skulist">
                                        {product.skus.length ? (
                                          product.skus.map((sku) => {
                                            const isskuselected =
                                              featureSelectedSkus.includes(
                                                sku.id,
                                              );

                                            return (
                                              <div
                                                key={sku.id}
                                                className="feature-products-skuitem"
                                                onClick={() =>
                                                  handleFeatureSkuToggle(
                                                    product,
                                                    sku.id,
                                                  )
                                                }
                                              >
                                                <div className="feature-products-skucheck">
                                                  <div
                                                    className={`feature-products-skucheckinner${
                                                      isskuselected
                                                        ? " feature-products-skucheckinner-active"
                                                        : ""
                                                    }`}
                                                  ></div>
                                                </div>
                                                <div className="feature-products-skuinfo">
                                                  <div className="feature-products-skuname">
                                                    {sku.color}
                                                  </div>
                                                  <div className="feature-products-skucode">
                                                    {sku.code}
                                                  </div>
                                                </div>
                                                <div className="feature-products-skustock">
                                                  Stock {sku.stock}
                                                </div>
                                              </div>
                                            );
                                          })
                                        ) : (
                                          <div className="campaign-products-empty">
                                            No SKUs found for this product
                                          </div>
                                        )}
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className="feature-products-selectionsummary">
                            <div className="feature-products-selectionsummary-count">
                              {featureSelectedSkuDetails.length} SKUs selected
                            </div>
                            <div className="feature-products-selectionsummary-meta">
                              From {featureSelectedProductDetails.length}{" "}
                              product
                              {featureSelectedProductDetails.length === 1
                                ? ""
                                : "s"}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div
                    className={`create-campain-step-panel-content${
                      currentFeatureStep === 3
                        ? " create-campain-step-panel-content-active"
                        : ""
                    }`}
                  >
                    <div className="feature-review-step">
                      <div className="feature-review-card">
                        <div className="feature-review-card-title">
                          Feature Summary
                        </div>
                        <div className="feature-review-section">
                          <div className="feature-review-label">
                            Campaign Duration
                          </div>
                          <div className="feature-review-value">
                            {featureReviewDuration}
                          </div>
                        </div>
                        <div className="feature-review-section">
                          <div className="feature-review-label">Category</div>
                          <div className="feature-review-tags">
                            {featureSelectedCategoryDetails.length ? (
                              featureSelectedCategoryDetails.map((category) => (
                                <div
                                  key={category.id}
                                  className="feature-review-tag"
                                >
                                  {category.name}
                                </div>
                              ))
                            ) : (
                              <div className="feature-review-muted">
                                No categories selected
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="feature-review-section">
                          <div className="feature-review-label">
                            Selected Products & SKUs
                          </div>
                          <div className="feature-review-value">
                            {featureSelectedSkuDetails.length} SKUs from{" "}
                            {featureSelectedProductDetails.length} products
                          </div>
                        </div>
                      </div>
                      <div className="feature-review-metrics">
                        <div className="feature-review-metric-row">
                          <div className="feature-review-metric-label">
                            Credits Per Product
                          </div>
                          <div className="feature-review-metric-value">
                            {featureCreditsPerProduct}
                          </div>
                        </div>
                        <div className="feature-review-metric-row">
                          <div className="feature-review-metric-label">
                            Products Selected
                          </div>
                          <div className="feature-review-metric-value">
                            {featureProductsSelectedCount}
                          </div>
                        </div>
                        <div className="feature-review-metric-row feature-review-metric-row-total">
                          <div className="feature-review-metric-label-footer">
                            Total Credits Required
                          </div>
                          <div className="feature-review-metric-value">
                            {featureTotalCreditsRequired}
                          </div>
                        </div>
                      </div>
                      <div className="feature-review-remaining">
                        <div className="feature-review-remaining-label">
                          Remaining After Activation
                        </div>
                        <div className="feature-review-remaining-value">
                          {featureRemainingCredits}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="create-campain-cont-container-footer create-feature-cont-container-footer">
              <div
                className={`create-campain-footer-button create-campain-footer-button-back${
                  isFirstFeatureStep
                    ? " create-campain-footer-button-disabled"
                    : ""
                }`}
                onClick={() => {
                  if (!isFirstFeatureStep) {
                    setCurrentFeatureStep((prev) => prev - 1);
                  }
                }}
              >
                <div className="create-campain-footer-button-icon">
                  <ArrowBackIcon />
                </div>
                <div className="create-campain-footer-button-text">Back</div>
              </div>
              {isLastFeatureStep ? (
                <div className="create-campain-footer-review-actions">
                  {/* <div className="create-campain-footer-button create-campain-footer-button-draft">
                    <div className="create-campain-footer-button-text">
                      Save as Draft
                    </div>
                  </div> */}
                  <div
                    className="create-campain-footer-button create-campain-footer-button-next"
                    onClick={HandleCreateFeature}
                  >
                    <div className="create-campain-footer-button-text">
                      Activate Feature
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`create-campain-footer-button create-campain-footer-button-next${
                    isLastFeatureStep
                      ? " create-campain-footer-button-disabled"
                      : ""
                  }`}
                  onClick={() => {
                    if (!isLastFeatureStep) {
                      setCurrentFeatureStep((prev) => prev + 1);
                    }
                  }}
                >
                  <div className="create-campain-footer-button-text">Next</div>
                  <div className="create-campain-footer-button-icon">
                    <ArrowFront />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PromotionsAndMarketing;
